import React, { useState, forwardRef, useRef, useMemo } from "react";
import JoditEditor from "jodit-react";
import { Jodit } from "jodit";

const TextEditor = forwardRef((props, ref) => {
    const { format, setFormat } = props;
    const editor = useRef(null);

    const buttons = [
        "undo",
        "redo",
        "|",
        "bold",
        "strikethrough",
        "underline",
        "italic",
        "|",
        "superscript",
        "subscript",
        "|",
        "align",
        "|",
        "ul",
        "ol",
        "outdent",
        "indent",
        "|",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        "link",
        "table",
        "|",
        "hr",
        "eraser",
        "copyformat",
        "|",
        "selectall",
        "preview",
        "|",
        "source",
        "|"
    ];
    const editorConfig = useMemo(() => ({
        controls: {
            font: {
                list: Jodit.atom({
                    'Helvetica,sans-serif': 'Helvetica',
                    'Arial,Helvetica,sans-serif': 'Arial',
                    'Georgia,serif': 'Georgia',
                    'Impact,Charcoal,sans-serif': 'Impact',
                    'Tahoma,Geneva,sans-serif': 'Tahoma',
                    'Times New Roman,Times,serif': 'Times New Roman',
                    'Verdana,Geneva,sans-serif': 'Verdana',
                    'Bookman Old Style': 'Bookman Old Style',
                })
            }
        },
        toolbar: true,
        spellcheck: true,
        language: "en",
        toolbarButtonSize: "medium",
        toolbarAdaptive: false,
        showCharsCounter: true,
        showWordsCounter: true,
        showXPathInStatusbar: false,
        buttons: buttons,
        uploader: {
            insertImageAsBase64URI: true
        },
        disablePlugins: "powered-by-jodit",
        minHeight: 400,
        useExtraClassesOptions: true,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: "insert_only_text"
    }), []);

    const handleBlur = (val) => {
        setFormat(val);
    };

    return (
        <JoditEditor
            className="w-100"
            ref={editor}
            value={format}
            config={editorConfig}
            tabIndex={1} // tabIndex of textarea
            onBlur={newContent => { handleBlur(newContent) }} // preferred to use only this option to update the format for performance reasons

        />
    );
});

export default TextEditor;

